module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/cover#cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("LIST OF MAPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/illustrations#illustrations"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#acknowledgments"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/author#author"
    }
  }, [_vm._v("AUTHOR’S NOTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontispiece#frontispiece"
    }
  }, [_vm._v("Battle of Atlanta Lithograph")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#introduction"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("INTRODUCTION")]), _vm._v(" “The Dissatisfaction with Mr. Lincoln Grows to Abhorrence”")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("  1. Closing the Vise")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  2. Prelude")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  3. The Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  4. Behind the Lines")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  5. Repulse")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  6. Sacrifice")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  7. Two-Sided Fight")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  8. Bloody Diversion")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  9. A Human Hurricane on Horseback")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 10. Desperation")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" 11. Impact")])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/order#order",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("APPENDIX")]), _vm._v(" Order of Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also By Gary Ecelbarger")])])]), _vm._v(" "), _c('p', {
    staticClass: "cbmh"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0